import React, { useState } from 'react'
import { CCol, CRow } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import './table.css'
import { Link } from 'react-router-dom'

export const EMPLOYEE_TYPE_OFFICER = 1;
export const EMPLOYEE_TYPE_STAFF = 2;
export const EMPLOYEE_TYPE_WORKER = 3;

export const EMPLOYEE_TYPE_NAME = {
  1: 'Officer',
  2: 'Staff',
  3: 'Worker'
};

export default function DataReportTable({ reportData, setReportData, formatDate }) {
  const [sortedKey, setSortedKey] = useState('')
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc',
  })
  const sortTable = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    const sorted = [...reportData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })
    setReportData(sorted)
    setSortedKey(key)
    setSortConfig({ key, direction })
  }
  return (
    <>
      <thead className="thead-dark" style={{ backgroundColor: '#e8e9eb' }}>
        <tr>
          <th onClick={() => sortTable('id')}>Sr No.</th>
          <th onClick={() => sortTable('id')} style={{width:'5%'}}>
            ID{' '}
            {sortedKey === 'id' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('full_name')}  style={{width:'20%'}}>
            Full Name
            {sortedKey === 'full_name' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('designation')}>
            Designation
            {sortedKey === 'designation' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('department')}>
            Department
            {sortedKey === 'department' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('branch')}>
            Branch
            {sortedKey === 'branch' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
            </th>
          <th onClick={() => sortTable('date_of_joining')}>
            Date Of Joining
            {sortedKey === 'date_of_joining' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('date_of_leaving')}>
            Date Of Leaving
            {sortedKey === 'date_of_leaving' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('reason')}  style={{width:'25%'}}>
            Reason
            {sortedKey === 'reason' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
            </th>
        </tr>
      </thead>
      <tbody>
        {reportData.map((item, index) => (
          <tr key={item.id}>
            <td>{index + 1}</td>
            <td style={{ color: 'blue' }}>
              <Link
                to={`/employee-profile?id=${item.employee_id}`}
                target="_blank"
              >
                {item.employee_id}
              </Link>
            </td>
            <td style={{ color: 'blue' }}>
              <Link
                to={`/employee-profile?id=${item.employee_id}`}
                target="_blank"
              >
                {item.employee.full_name}
              </Link>
            </td>
            <td>{item.employee.designation.name}</td>
            <td>{item.employee.department.name}</td>
            <td>{item.employee.branch.name}</td>
            <td>{formatDate(item.employee.date_of_joining)}</td>
            <td>{formatDate(item.resignation_date)}</td>
            <td>{item.reason}</td>

       

          </tr>
        ))}
      </tbody>
    </>
  )
}
